const STATES = {
    CLIENT_CONFIRMED: 'clientConfirmed',
    CLIENT_FORM: 'clientForm',
    CLIENT_FORM_MINI: 'clientFormMini',
};

export default STATES;



// WEBPACK FOOTER //
// ./src/app/constants/state.constants.js